import { ReactComponent as FlagIcon } from "./svg/jp-flag.svg";
import "../flag-icon.scss";

export const JPFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
